export const steps = [
  { id: 1, label: "Community Info" },
  { id: 2, label: "License Info" },
  { id: 3, label: "Financial Info" },
  { id: 4, label: "Approval Info" },
];
